import {
  Alert,
  Button,
  Center,
  Divider,
  Paper,
  Stack,
  Text,
  TextInput,
  Title
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconShieldCheck } from "@tabler/icons-react";
import { useState } from "react";

export const SignInPage = () => {
  const [devError, setDevError] = useState<string | null>(null);
  const [devLoading, setDevLoading] = useState(false);

  const devForm = useForm({
    initialValues: { email: "", name: "" },
    validate: {
      email: (v: string) => (/^\S+@\S+\.\S+$/u.test(v.trim()) ? null : "Valid email required")
    }
  });

  const handleDevSignIn = devForm.onSubmit(async (values) => {
    setDevLoading(true);
    setDevError(null);
    try {
      const res = await fetch("/auth/dev-signin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: values.email.trim(), name: values.name.trim() || undefined })
      });
      if (res.ok) {
        window.location.href = "/";
      } else {
        const body = (await res.json().catch(() => ({}))) as { error?: unknown };
        const msg = typeof body.error === "string" ? body.error : `HTTP ${res.status}`;
        setDevError(msg);
      }
    } catch (err) {
      setDevError(err instanceof Error ? err.message : "Network error");
    } finally {
      setDevLoading(false);
    }
  });

  return (
    <Center
      h="100vh"
      style={{ background: "linear-gradient(160deg, #f0eeff 0%, #f4f5f7 55%, #eef3fc 100%)" }}
    >
      <Paper
        shadow="sm"
        p="xl"
        radius="md"
        style={{ width: 380, border: "1px solid #e5e7eb", backgroundColor: "#ffffff" }}
      >
        <Stack align="center" gap="md">
          <IconShieldCheck size={40} color="#7950f2" />
          <Title order={2} ta="center">
            Veritrellis Ops
          </Title>
          <Text c="dimmed" size="sm" ta="center">
            Internal team console.
          </Text>
          <Button component="a" href="/auth/sign-in" fullWidth size="md" variant="filled">
            Sign in with SSO (Authentik)
          </Button>

          <Divider label="or dev sign-in" labelPosition="center" w="100%" />

          <form onSubmit={handleDevSignIn} style={{ width: "100%" }}>
            <Stack gap="sm">
              <TextInput
                label="Your email"
                placeholder="you@example.com"
                required
                {...devForm.getInputProps("email")}
              />
              <TextInput
                label="Display name (optional)"
                placeholder="Your name"
                {...devForm.getInputProps("name")}
              />
              {devError ? (
                <Alert color="red" variant="light">
                  {devError === "not_found" || devError.startsWith("HTTP 404")
                    ? "Dev auth is not enabled on this server."
                    : devError}
                </Alert>
              ) : null}
              <Button type="submit" loading={devLoading} variant="default" fullWidth>
                Dev sign-in (local only)
              </Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Center>
  );
};
